import { render, staticRenderFns } from "./BlogCard2.vue?vue&type=template&id=5690ce06&scoped=true&"
import script from "./BlogCard2.vue?vue&type=script&lang=js&"
export * from "./BlogCard2.vue?vue&type=script&lang=js&"
import style0 from "./BlogCard2.vue?vue&type=style&index=0&id=5690ce06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5690ce06",
  null
  
)

component.options.__file = "BlogCard2.vue"
export default component.exports